import {customElement} from 'lit/decorators.js';
import {FilterView} from './filter-view';
import {Spell} from './spell';

@customElement('ri-spells')
export class Spells extends FilterView {
  get spells(): Spell[] {
    return this.filterables as Spell[];
  }
  set spells(value) {
    this.filterables = value;
  }
  override name = '施法';
  override subtitle = '单击以强制转换，拖动到队列。';
  override intersection = true;
  override possibleFilters = new Set([
    {name: 'lightMagic', displayName: 'Light'},
    {name: 'fireMagic', displayName: 'Fire'},
    {name: 'timeMagic', displayName: 'Time'},
    {name: 'spaceMagic', displayName: 'Space'},
    {name: 'combat', displayName: 'Combat'},
  ]);
  override filters = new Set([]);
  constructor() {
    super();
    // realtime spells (mostly Time Magic) cooldown according to irl time,
    // while others cooldown based on game time.
    let lastTime = 0;
    const loop = (now: number) => {
      if (!lastTime) lastTime = now;
      for (const spell of this.spells.filter((spell) =>
        spell.tags.has('realtime')
      )) {
        spell.currentCooldown = spell.currentCooldown.minus(
          (now - lastTime) / 1000
        );
      }
      lastTime = now;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }
}
